export const translations = {
  it: {
    // Header
    findDealer: 'Trova Rivenditore',
    support: 'Assistenza',
    
    // Step Navigation
    step1Label: 'Il Tuo Giardino',
    step2Label: 'Seleziona Kit',
    step3Label: 'Riepilogo',
    
    // Step 1 - Garden Drawing (NEW - First Section)
    drawYourGarden: 'Disegna il tuo giardino',
    drawGardenSubtitle: 'Ti suggeriamo il kit più adatto alla tua area',
    howItWorks: 'Come funziona',
    howItWorksDesc: 'Disegna il perimetro del tuo giardino sulla mappa per calcolare automaticamente l\'area.',
    
    // Step 1 - Contact Form (NEW - Second Section)
    contactTitle: 'A chi dobbiamo mandare il preventivo',
    contactSubtitle: 'Inserisci i tuoi dati per ricevere il preventivo per il tuo spazio verde senza zanzare.',
    contactData: 'Dati di Contatto',
    firstName: 'Nome',
    firstNamePlaceholder: 'Mario',
    lastName: 'Cognome',
    lastNamePlaceholder: 'Rossi',
    fullName: 'Nome e Cognome',
    fullNamePlaceholder: 'Mario Rossi',
    email: 'Email',
    emailPlaceholder: 'mario.rossi@email.com',
    phone: 'Telefono',
    phonePlaceholder: '+39 333 1234567',
    province: 'Regione / Provincia',
    provincePlaceholder: 'Seleziona regione',
    
    // Validation
    nameRequired: 'Il nome è obbligatorio',
    nameMinLength: 'Inserisci il nome completo',
    firstNameRequired: 'Il nome è obbligatorio',
    lastNameRequired: 'Il cognome è obbligatorio',
    postcodeRequired: 'Il CAP è obbligatorio',
    postcodeInvalid: 'CAP non valido (4-6 cifre)',
    emailRequired: 'L\'email è obbligatoria',
    emailInvalid: 'Inserisci un\'email valida',
    phoneRequired: 'Il telefono è obbligatorio',
    phoneInvalid: 'Inserisci un numero valido',
    provinceRequired: 'Seleziona una regione',
    
    // Step 1 - Map
    measureGarden: 'Misura Area Giardino',
    measureGardenDesc: 'Disegna l\'area del tuo giardino sulla mappa per trovare il kit perfetto.',
    drawGarden: 'Disegna Area Giardino',
    manualInput: 'Inserisci area manualmente',
    areaPlaceholder: 'Area in m²',
    searchAddress: 'Cerca indirizzo (opzionale)',
    searchPlaceholder: 'Inserisci via, città o CAP',
    drawInstructions1: 'Clicca "Disegna"',
    drawInstructions2: 'Posiziona punti sulla mappa',
    drawInstructions3: 'Clicca "Fine"',
    draw: 'Disegna',
    undo: 'Annulla',
    finish: 'Fine',
    delete: 'Elimina',
    clickOnMap: 'Clicca sulla mappa',
    points: 'punti',
    area: 'Area',
    noAreaYet: 'Nessuna area',
    yourGardenArea: 'La Tua Area Giardino',
    continueToKit: 'Continua alla Selezione Kit',
    mapLayerHint: 'Cambia vista mappa: icona in alto a destra',
    streetMap: 'Mappa Stradale',
    satellite: 'Satellite',
    hybrid: 'Ibrido',
    startDrawing: 'Inizia a disegnare',
    
    // Step 2 - Kit Selection
    selectKit: 'Seleziona Kit',
    basedOnArea: 'In base alla tua area',
    recommendIdealKit: 'ti consigliamo il kit ideale.',
    recommended: 'Consigliato',
    morePower: 'Più Potenza',
    selected: 'Selezionato',
    continue: 'Continua',
    backToGarden: 'Torna al Giardino',
    
    // Step 3 - Summary
    summary: 'Riepilogo',
    checkData: 'Verifica i tuoi dati e invia la richiesta.',
    yourKit: 'Il Tuo Kit',
    clickToEnlarge: 'Clicca sull\'immagine per ingrandire',
    yourGardenSize: 'La Tua Area Giardino',
    priceIndication: 'Indicazione Prezzo',
    finalPriceNote: 'Il prezzo finale sarà confermato dal rivenditore autorizzato.',
    yourContactDetails: 'I Tuoi Dati di Contatto',
    submitRequest: 'Invia Richiesta',
    dealerContactNote: 'Un rivenditore ti contatterà entro 24-48 ore lavorative.',
    backToKit: 'Torna alla Selezione Kit',
    
    // Success
    requestSent: 'Richiesta Inviata',
    thankYou: 'Grazie! Un rivenditore autorizzato della tua zona ti contatterà entro 24-48 ore lavorative per confermare la soluzione giusta.',
    nextStep1: 'Riceverai un\'email di conferma.',
    nextStep2: 'Il rivenditore ti contatterà per domande su area o accessori.',
    nextStep3: 'Completa l\'acquisto direttamente con il rivenditore.',
    yourSelection: 'La Tua Selezione',
    forGardenArea: 'Per',
    gardenArea: 'area giardino',
  }
};

export const supportedLanguages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' }
];

export const defaultLanguage = 'it';
